import { Firebase } from "@/services/firebase";

const remoteConfig = Firebase.remoteConfig();

remoteConfig.defaultConfig = {
  beta_complete_date: "09/01/2020",
  required_version: "0.1",
  recommended_version: "0.1",
};

export default remoteConfig;
